import { PageTable, Header } from '/src/layouts/page';
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from '/src/components/modal/ApiModal/ApiModal';

import { useNavigate } from "react-router-dom";
import capitalizeFirstLetter from '../../../../../utils/capitalizeFirstLetter';
import { formatDate } from '/src/utils/formatDate';
import Table from '/src/components/table';
import CountryTable from '/src/features/dataset/components/table/CountryTable/CountryTable';
import "./DatasetIvy.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import datasetService from '/src/features/dataset/services/datasetService';
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import hasPermission from '/src/utils/hasPermission';

function DatasetIvy() {
    const { getDatasetsIvy, deleteDataset } = datasetService;

    const navigate = useNavigate();

    const cells = [
        {
            column: 'NAME',
            name: 'name',
            sort: true,
            show: (value) => <span style={{ fontWeight: 700 }}>{capitalizeFirstLetter(value)}</span>
        },
        {
            column: 'LANGUAGE',
            name: 'language.slug',
            show: (value) => <CountryTable iconName={value.toLowerCase()}></CountryTable>
        },
        {
            column: 'DESCRIPTION',
            name: 'description',
            show: (value) => capitalizeFirstLetter(value)
        },
        {
            column: 'LAST UPDATE',
            name: 'updated_at',
            sort: true,
            show: (value) => formatDate(value)
        },
        {
            column: 'CONVERSATION MODE',
            name: 'dataset_type_id',
            show: (value) => value != 2 ? <i className="fa fa-check" aria-hidden="true" style={{ color: "var(--green)" }} /> : <span style={{ color: "var(--pink)", fontWeight: "bolder" }}>X</span>
        }
    ];


    const onClickUpdate = ({ row, updateRow, getIndex }) => navigate(urlWithRoutingCompany('dataset/update'), { state: { data: row } });

    //const onClickRedirect = ({ row }) => naviguate('/bot/' + row.name);
    const onClickRedirect = ({ row }) => navigate(urlWithRoutingCompany('datasets/' + row.name));
    const onClickAdd = ({ deleteRow, row }) => navigate(urlWithRoutingCompany('dataset/create'));

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, name } = row;

        await ModalManager.show(ApiModal, {
            title: 'Delete dataset ' + name,
            body: 'Do you really want to delete the dataset ' + name + " ?",
            api: {
                request: deleteDataset,
                param: [row.id]
            },
            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
            confirm: {
                name: name,
                fieldName: "the dataset",
            }
        }).then(() => deleteRow(id))

    };

    const actions = [
        hasPermission('update_dataset') ? { className: "fas fa-cog action-button edit_action", style: {}, onClick: onClickUpdate } : null,
        hasPermission('update_dataset') ? { className: "fas fa-edit action-button profil_action", style: {}, onClick: onClickRedirect } : null,
        hasPermission('delete_dataset') ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete } : null,
    ].filter(action => action);

    const buttons = [
        hasPermission('create_dataset') ? { icon: "fas fa-plus", onClick: onClickAdd } : null
    ].filter(button => button);

    
    const filters = [
        { type: 'input', placeholder: 'content', name: 'term' },
    ]

    return (
        <Table name="Dataset" cells={cells} api={getDatasetsIvy} actions={actions} buttons={buttons} filters={filters}></Table>
    );
}

export default DatasetIvy;